export enum ResponseStatus {
  Active = 0,

  ScaledDown = 1,

  Declined = 2,

  Pending = 3,
}
